import { render, staticRenderFns } from "./table-date.vue?vue&type=template&id=6b66924e&"
import script from "./table-date.vue?vue&type=script&lang=js&"
export * from "./table-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports